import Crud from './crud'
var crud = new Crud('cost_weights', 'giá gốc');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        StorageID: null,
        ProductType: null,
        CostWeight: 0,
        CostVolume: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
